import { Minicart } from '../../../../vtex-apps/minicart/Minicart/default';
import { MinicartBaseContent } from '../../../../vtex-apps/minicart/MinicartBaseContent/default';
import { v4 as uuidv4 } from 'uuid';

const MinicartGroup = () => {
	return {
		componentName: 'Minicart',
		componentId: uuidv4(),
		componentGroup: 'MinicartGroup',
		props: Minicart().props,
		childrenComponents: [MinicartBaseContent()],
	};
};

export default MinicartGroup;
